// extracted by mini-css-extract-plugin
export default {"title":"types_title__vcdta","wrapper":"types_wrapper__H2UAU","desc":"types_desc__A2F9S","icon":"types_icon__JWULE"};